import React, { PropsWithChildren } from 'react';
import { Box } from '../../../box';
import { Roundel } from '../../../roundel';
import { Tokens, name } from '../../const';
import { styled } from '../../../../theme';

const IconRoot = styled(Box, { name, slot: 'HeaderIcon' })({
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  top: Tokens.HeaderIconTop(),
}) as unknown as typeof Box;

export const HeaderIcon: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <IconRoot>
      <Roundel>{children}</Roundel>
    </IconRoot>
  );
};
